import { VocalRange } from '../../../../../common/src/model.ts';
import { RandomSource } from '../../../../../common/src/rhythm_echo.ts';
import { pickPhraseHomeNote, SolfegePhrase } from '../../../../../common/src/sing_in_solfege.ts';
import { SolfegeSessionPhrase } from './solfege_session.ts';

// Where each phrase of a Sing in Solfège session sits (issue #3722): its own do, chosen by Interval
// Training's rule (pickPhraseHomeNote, common/src/sing_in_solfege.ts) near the singer's staff where
// the range allows, so the staff stays short and the do moves from phrase to phrase. The plan's
// decision "Every note inside the saved range" is the shared rule's own: it drops the staff's limit
// before it gives up any of the singer's range, so every note of a phrase that fits the saved range
// lands inside it, and a phrase wider than the range (served only when none fits) sits as close to
// it as it can. Pure, so it is tested without the page.

export interface PlacementOptions {
  random?: RandomSource;
  previous?: number; // the do of the phrase before, which the next one avoids where it can
  within?: VocalRange; // the notes on or near the singer's staff (nearStaffMidiRange)
}

// The session's phrases in order, each with its do, each do avoiding the one before it
export function placeSolfegePhrases(
  range: VocalRange,
  phrases: SolfegePhrase[],
  { random = Math.random, previous, within }: PlacementOptions = {},
): SolfegeSessionPhrase[] {
  let before = previous;
  return phrases.map((phrase) => {
    const homeMidi = pickPhraseHomeNote(range, phrase, random, before, within);
    before = homeMidi;
    return { phrase, homeMidi };
  });
}
